import React from 'react';
import { content } from '../content';
import { useTypewriter } from '../hooks/useTypewriter';

const { terminal } = content;

/**
 * Isolated on purpose: the typewriter re-renders on every character, and the
 * sidebar around it (nav, live stats, author) has no reason to re-render with it.
 */
const Terminal = () => {
  const typed = useTypewriter(terminal.lines);

  return (
    <div className="terminal">
      <p className="terminal__prompt">{terminal.prompt}</p>
      <div className="terminal__output">
        {terminal.lines.map((line, index) => (
          // The full line is rendered transparently underneath so the block
          // never changes height while the text types itself out.
          <p key={index} className="terminal__line">
            <span className="terminal__ghost" aria-hidden>
              {line}
            </span>
            <span className="terminal__typed">{typed[index] ?? ''}</span>
          </p>
        ))}
      </div>
      <span className="terminal__caret" aria-hidden />
    </div>
  );
};

export default Terminal;
